export const AUTH_RETURN_PATH_KEY = "cuberite.auth.returnPath";

// Public routes remain usable without triggering an authentication redirect.
export const PUBLIC_PATHS = Object.freeze(["/", "/forgot-password", "/reset-password"]);

// These routes expose authenticated application data. Public web applications
// such as HAPK and EXHI deliberately remain outside this list.
export const PROTECTED_PREFIXES = Object.freeze([
  "/home",
  "/box",
  "/ccon",
  "/tabl",
  "/mfm",
  "/champ",
]);

export function isProtectedPath(pathname) {
  const path = String(pathname || "/").split(/[?#]/, 1)[0] || "/";
  return PROTECTED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix + "/")
  );
}

export function sanitizeReturnPath(candidate) {
  if (typeof candidate !== "string") return null;
  const value = candidate.trim();
  if (!value.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return null;
  }
  if ([...value].some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  })) return null;

  try {
    const parsed = new URL(value, "http://cuberite.invalid");
    if (parsed.origin !== "http://cuberite.invalid") return null;
    const safe = parsed.pathname + parsed.search + parsed.hash;
    return isProtectedPath(parsed.pathname) ? safe : null;
  } catch (_) {
    return null;
  }
}

export function sanitizeSameOriginDestination(
  candidate,
  currentOrigin = window.location.origin
) {
  if (typeof candidate !== "string" || !candidate.trim()) return null;
  try {
    const parsed = new URL(candidate.trim(), currentOrigin);
    if (parsed.origin !== currentOrigin || parsed.username || parsed.password) return null;
    return parsed.pathname + parsed.search + parsed.hash;
  } catch (_) {
    return null;
  }
}

export function rememberReturnPath(candidate, storage = window.sessionStorage) {
  const safe = sanitizeReturnPath(candidate);
  if (!safe) return null;
  try {
    storage.setItem(AUTH_RETURN_PATH_KEY, safe);
  } catch (_) {}
  return safe;
}

export function consumeReturnPath(storage = window.sessionStorage) {
  let value = null;
  try {
    value = storage.getItem(AUTH_RETURN_PATH_KEY);
    storage.removeItem(AUTH_RETURN_PATH_KEY);
  } catch (_) {}
  return sanitizeReturnPath(value);
}
